module.exports = __webpack_public_path__ + "img/bam.bd9465cd.png";